// extracted by mini-css-extract-plugin
export default {"component":"L6EuKN","headline":"idP1De","mobile":"QJktpB","banners":"QURzbJ"};